












































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Form, FormItem, Input, Option, Select } from 'element-ui';

import {
  ContainerInformationInput,
  ShipmentFields,
  ShipmentUpdateInput
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';

import { containerSizeOptions } from '@/constants/containerSizeOptions';

@Component({
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class ContainerInfo extends Vue {
  @Prop() shipment!: ShipmentFields;

  editMode = false;
  containerSizeOptions = containerSizeOptions();

  containerInput: ContainerInformationInput = {
    containerNumber: null,
    containerReference: null,
    containerType: null
  };

  containerInformation: ContainerInformationInput[] = [this.containerInput];

  created() {
    this.setContainerInput();
  }

  addContainer() {
    this.resetContainerInput();
    this.containerInformation.push(this.containerInput);
  }

  deleteContainer(index) {
    this.containerInformation.splice(index, 1);
  }

  toggleEdit() {
    this.editMode = !this.editMode;
    this.setContainerInput();
  }

  cancel() {
    this.toggleEdit();
    this.setContainerInput();
  }

  submit() {
    const id = this.shipment.id;
    const containerInformation = this.containerInformation;
    this.$store.dispatch('Shipment/updateShipment', {
      id,
      containerInformation
    });
    this.resetContainerInput();
    this.toggleEdit();
  }

  setContainerInput() {
    this.containerInformation = this.shipment.containerInformation.length
      ? [...this.shipment.containerInformation]
      : [{ ...this.containerInput }];
  }

  resetContainerInput() {
    this.containerInput = {
      containerNumber: null,
      containerReference: null,
      containerType: null
    };
  }
}
